const toPythonDebug = function (Blockly) {

    Blockly.PythonDebug = new Blockly.Generator("PythonDebug");
    Blockly.PythonDebug.addReservedWords("False,None,True,and,as,assert,break,class,continue,def,del,elif,else,except,exec,finally,for,from,global,if,import,in,is,lambda,nonlocal,not,or,pass,print,raise,return,try,while,with,yield,NotImplemented,Ellipsis,__debug__,quit,exit,copyright,license,credits,ArithmeticError,AssertionError,AttributeError,BaseException,BlockingIOError,BrokenPipeError,BufferError,BytesWarning,ChildProcessError,ConnectionAbortedError,ConnectionError,ConnectionRefusedError,ConnectionResetError,DeprecationWarning,EOFError,Ellipsis,EnvironmentError,Exception,FileExistsError,FileNotFoundError,FloatingPointError,FutureWarning,GeneratorExit,IOError,ImportError,ImportWarning,IndentationError,IndexError,InterruptedError,IsADirectoryError,KeyError,KeyboardInterrupt,LookupError,MemoryError,ModuleNotFoundError,NameError,NotADirectoryError,NotImplemented,NotImplementedError,OSError,OverflowError,PendingDeprecationWarning,PermissionError,ProcessLookupError,RecursionError,ReferenceError,ResourceWarning,RuntimeError,RuntimeWarning,StandardError,StopAsyncIteration,StopIteration,SyntaxError,SyntaxWarning,SystemError,SystemExit,TabError,TimeoutError,TypeError,UnboundLocalError,UnicodeDecodeError,UnicodeEncodeError,UnicodeError,UnicodeTranslateError,UnicodeWarning,UserWarning,ValueError,Warning,ZeroDivisionError,_,__build_class__,__debug__,__doc__,__import__,__loader__,__name__,__package__,__spec__,abs,all,any,apply,ascii,basestring,bin,bool,buffer,bytearray,bytes,callable,chr,classmethod,cmp,coerce,compile,complex,copyright,credits,delattr,dict,dir,divmod,enumerate,eval,exec,execfile,exit,file,filter,float,format,frozenset,getattr,globals,hasattr,hash,help,hex,id,input,int,intern,isinstance,issubclass,iter,len,license,list,locals,long,map,max,memoryview,min,next,object,oct,open,ord,pow,print,property,quit,range,raw_input,reduce,reload,repr,reversed,round,set,setattr,slice,sorted,staticmethod,str,sum,super,tuple,type,unichr,unicode,vars,xrange,zip");
    Blockly.PythonDebug.ORDER_ATOMIC = 0;
    Blockly.PythonDebug.ORDER_COLLECTION = 1;
    Blockly.PythonDebug.ORDER_STRING_CONVERSION = 1;
    Blockly.PythonDebug.ORDER_MEMBER = 2.1;
    Blockly.PythonDebug.ORDER_FUNCTION_CALL = 2.2;
    Blockly.PythonDebug.ORDER_EXPONENTIATION = 3;
    Blockly.PythonDebug.ORDER_UNARY_SIGN = 4;
    Blockly.PythonDebug.ORDER_BITWISE_NOT = 4;
    Blockly.PythonDebug.ORDER_MULTIPLICATIVE = 5;
    Blockly.PythonDebug.ORDER_ADDITIVE = 6;
    Blockly.PythonDebug.ORDER_BITWISE_SHIFT = 7;
    Blockly.PythonDebug.ORDER_BITWISE_AND = 8;
    Blockly.PythonDebug.ORDER_BITWISE_XOR = 9;
    Blockly.PythonDebug.ORDER_BITWISE_OR = 10;
    Blockly.PythonDebug.ORDER_RELATIONAL = 11;
    Blockly.PythonDebug.ORDER_LOGICAL_NOT = 12;
    Blockly.PythonDebug.ORDER_LOGICAL_AND = 13;
    Blockly.PythonDebug.ORDER_LOGICAL_OR = 14;
    Blockly.PythonDebug.ORDER_CONDITIONAL = 15;
    Blockly.PythonDebug.ORDER_LAMBDA = 16;
    Blockly.PythonDebug.ORDER_NONE = 99;
    Blockly.PythonDebug.ORDER_OVERRIDES = [
        [Blockly.PythonDebug.ORDER_FUNCTION_CALL, Blockly.PythonDebug.ORDER_MEMBER],
        [Blockly.PythonDebug.ORDER_FUNCTION_CALL, Blockly.PythonDebug.ORDER_FUNCTION_CALL],
        [Blockly.PythonDebug.ORDER_MEMBER, Blockly.PythonDebug.ORDER_MEMBER],
        [Blockly.PythonDebug.ORDER_MEMBER, Blockly.PythonDebug.ORDER_FUNCTION_CALL],
        [Blockly.PythonDebug.ORDER_LOGICAL_NOT, Blockly.PythonDebug.ORDER_LOGICAL_NOT],
        [Blockly.PythonDebug.ORDER_LOGICAL_AND, Blockly.PythonDebug.ORDER_LOGICAL_AND],
        [Blockly.PythonDebug.ORDER_LOGICAL_OR, Blockly.PythonDebug.ORDER_LOGICAL_OR]
    ];
    Blockly.Variables.allUsedVariabless = function (a) {
        if (a instanceof Blockly.Block) var b = a.getDescendants(!1);
        else if (a instanceof Blockly.Workspace || a instanceof Blockly.WorkspaceSvg) b = a.getAllBlocks();
        else throw new Error("Not Block or Workspace: " + a);
        var c = Blockly.Variables.noVariableText();
        a = Object.create(null);
        for (var d = 0; d < b.length; d++) {
            var e = b[d].getVarModels();
            if (e)
                for (var f = 0; f < e.length; f++) {
                    var g = e[f];
                    // g.getId() && g.name.toLowerCase() != c && (a[g.name.toLowerCase()] = g.name)
                    if (g.getId() && g.name.toLowerCase() !== c) {
                        if (g.type === "") {
                            if (!a['']) {
                                a[''] = {}
                            }
                            a[''][g.name.toLowerCase()] = g.name
                        } else if (g.type === "list") {
                            if (!a['list']) {
                                a['list'] = {}
                            }
                            a['list'][g.name.toLowerCase()] = g.name
                        } else {

                        }
                    }
                }
        }
        let obj = {}
        for (let i in a) {
            let b = []
            for (let j in a[i]) {
                b.push(a[i][j])
            }
            obj[i] = b
        }

        // b = [];
        // for (var h in a) b.push(a[h]);
        return obj
    };
    Blockly.PythonDebug.init = function (a) {
        this.INDENT = ''
        Blockly.PythonDebug.PASS = this.INDENT + "pass\r\n";
        Blockly.PythonDebug.definitions_ = Object.create(null);
        Blockly.PythonDebug.functionNames_ = Object.create(null);
        Blockly.PythonDebug.jmdstart = Object.create(null); //拿到头部文件作为最后的函数调用
        Blockly.PythonDebug.list = Object.create(null);
        Blockly.PythonDebug.varibles = new Array();
        Blockly.PythonDebug.variableDB_ ? Blockly.PythonDebug.variableDB_.reset() : Blockly.PythonDebug.variableDB_ = new Blockly.Names(Blockly.PythonDebug.RESERVED_WORDS_);
        Blockly.PythonDebug.variableDB_.setVariableMap(a.getVariableMap());
        for (var b = [], c = Blockly.Variables.allDeveloperVariables(a), d = 0; d < c.length; d++) b.push(c[d] +
            " = 0");
        // a = Blockly.Variables.allUsedVariables(a);
        a = Blockly.Variables.allUsedVariabless(a)
        for (let i in a) {
            for (let j in a[i]) {
                let varname = a[i][j]
                if (i === "") {
                    varname = 'VAR_' + varname
                    b.push(varname + " = 0")
                } else {
                    varname = 'LIST_' + varname
                    b.push(varname + " = []")
                }
                Blockly.PythonDebug.varibles.push(varname)
            }
        }
        // for (d = 0; d < a.length; d++) {
        //     Blockly.PythonDebug.varibles.push(a[d])
        //     if (a[d].type == "lists") {
        //         b.push(a[d] + " = []")
        //     } else {
        //         b.push(a[d] + " = 0")
        //     }
        // };

        Blockly.PythonDebug.definitions_.variables = b.join("\r\n")
    };
    Blockly.PythonDebug.finish = function (a) {
        var b = [],
            c = [],
            f = [],
            h = [],
            d,
            l = '';
        for (d in Blockly.PythonDebug.definitions_) {
            var e = Blockly.PythonDebug.definitions_[d];
            e.match(/^(from\s+\S+\s+)?import\s+\S+/) ? b.push(e) : c.push(e)
        }
        //遍历有多少个头部块，就在最后添加对应的函数调用
        for (var g in Blockly.PythonDebug.jmdstart) {
            f.push(Blockly.PythonDebug.jmdstart[g] + "()")
        }

        //遍历列表的所有参数
        for (let i in Blockly.PythonDebug.list) {
            h.push(i)
            l += i + '=[]\r\n'
        }
        a = Blockly.PythonDebug.varibles.length > 0 ? a.replace(/\[GLOBAL]/g, "\r\nglobal " + Blockly.PythonDebug.varibles.join(',')) : a.replace(/\[GLOBAL]/g, '')

        var thrad = f.length > 1 ? "import _thread\r\n" : ""
        var thradEnd = f.length > 1 ? Blockly.PythonDebug.mainEnd(f) : f.join("\r\n")

        delete Blockly.PythonDebug.definitions_;
        delete Blockly.PythonDebug.functionNames_;
        delete Blockly.PythonDebug.jmdstart;
        Blockly.PythonDebug.variableDB_.reset();
        return thrad + (b.join("\r\n") + "\r\n\r\n" + l + c.join("\r\n\r\n")).replace(/\n\n+/g, "\r\n\r\n").replace(/\n*$/, "\r\n\r\n") + a + "\r\n" + thradEnd
    };
    Blockly.PythonDebug.mainEnd = function (a) {
        let top = "def main():\r\n"
        for (let b in a) {
            top += "_thread.start_new_thread(" + a[b].replace("()", "") + ",())\r\n"
        }
        top += "\r\nmain();\r\n\r\nwhile 1:\r\npass"
        return top
    };
    Blockly.PythonDebug.scrubNakedValue = function (a) {
        return a + "\n"
    };
    Blockly.PythonDebug.quote_ = function (a) {
        a = a.replace(/\\/g, "\\\\").replace(/\n/g, "\\\n");
        var b = "'"; - 1 !== a.indexOf("'") && (-1 === a.indexOf('"') ? b = '"' : a = a.replace(/'/g, "\\'"));
        return b + a + b
    };
    Blockly.PythonDebug.multiline_quote_ = function (a) {
        a = a.replace(/'''/g, "\\'\\'\\'");
        return "'''" + a + "'''"
    };
    Blockly.PythonDebug.scrub_ = function (a, b, c) {
        var d = "";
        // if (!a.outputConnection || !a.outputConnection.targetConnection) {
        //     var e = a.getCommentText();
        // if (e) {
        //     e = Blockly.utils.wrap(e, Blockly.PythonDebug.COMMENT_WRAP - 3)
        //     d += Blockly.PythonDebug.prefixLines(e + "\n", "# ")
        // }
        // e && (e = Blockly.utils.wrap(e, Blockly.PythonDebug.COMMENT_WRAP - 3), d += Blockly.PythonDebug.prefixLines(e + "\n", "# "));
        //     for (var f = 0; f < a.inputList.length; f++) a.inputList[f].type === Blockly.INPUT_VALUE && (e = a.inputList[f].connection.targetBlock()) && (e = Blockly.PythonDebug.allNestedComments(e)) && (d += Blockly.PythonDebug.prefixLines(e, "# "))
        // }
        a = a.nextConnection && a.nextConnection.targetBlock();
        c = c ? "" : Blockly.PythonDebug.blockToCode(a);
        return d + b + c
    };
    // Blockly.PythonDebug.getAdjustedInt = function (a, b, c, d) {
    //     c = c || 0;
    //     a.workspace.options.oneBasedIndex && c--;
    //     var e = a.workspace.options.oneBasedIndex ? "1" : "0";
    //     a = Blockly.PythonDebug.valueToCode(a, b, c ? Blockly.PythonDebug.ORDER_ADDITIVE : Blockly.PythonDebug.ORDER_NONE) || e;
    //     Blockly.isNumber(a) ? (a = parseInt(a, 10) + c, d && (a = -a)) : (a = 0 < c ? "int(" + a + " + " + c + ")" : 0 > c ? "int(" + a + " - " + -c + ")" : "int(" + a + ")", d && (a = "-" + a));
    //     return a
    // };
    Blockly.PythonDebug.transformColor = function (color) {
        var colors = color.slice(1)
        var newColors = ''
        for (var j = 0; j < colors.length; j++) {
            if (colors[j] !== '0') {
                newColors = colors.slice(j)
                break;
            } else if (colors == '000000') {
                newColors = '0'
                break;
            }
        }
        var newColor = '';
        for (var i = 0; i < newColors.length; i++) {
            newColor += newColors[i].toLocaleUpperCase()
        }
        return '0x' + newColor

    }

    Blockly.PythonDebug.matrixToString16 = function (matrix) {
        let arr = []
        for (var i = 0; i < matrix.length;) {
            // 字符串翻转
            var length = (matrix.slice(i, i + 8)).length;
            length = length - 1;
            var newstr = ''
            for (var x = length; x >= 0; x--) {
                newstr += (matrix.slice(i, i + 8)).charAt(x);
            }

            arr.push(newstr)
            i += 8
        }
        let value = ''
        for (var j = 0; j < arr.length; j++) {
            let temp = parseInt(arr[j], 2)
            temp = temp.toString(16)
            // 十六进制，不够两位补0
            let zero = '00';
            let tmp = 2 - temp.length;
            value += zero.substr(0, tmp) + temp;

        }
        return value
    }



    //-------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------





    Blockly.PythonDebug.pass = "pass\r\n";

    Blockly.PythonDebug.jmd_start = function (a) {
        let task = a.getFieldValue("TASK");
        Blockly.PythonDebug.jmdstart[a.id] = task;
        Blockly.PythonDebug.definitions_.import_random = "import rcu";
        return "def " + task + "():[GLOBAL]\r\n";
    };
    Blockly.PythonDebug.jmd_getLeftButton = function (a) {
        return ["rcu.GetLeftButton()", 1];
    };
    Blockly.PythonDebug.jmd_getRightButton = function (a) {
        return ["rcu.GetRightButton()", 1];
    };
    Blockly.PythonDebug.jmd_getInMic = function (a) {
        return ["rcu.GetInMic()", 1];
    };
    Blockly.PythonDebug.jmd_getBatteryVoltage = function (a) {
        return ["rcu.GetInVotage()", 1];
    };
    Blockly.PythonDebug.jmd_getControlTime = function (a) {
        return ["rcu.GetSysTime()", 1];
    };
    Blockly.PythonDebug.jmd_setControlTimeZero = function (a) {
        return "rcu.SetSysTime()\r\n";
    };
    Blockly.PythonDebug.jmd_setBeep = function (a) {
        let state = a.getFieldValue("STATE");
        return "rcu.SetInBeep(" + state + ")\r\n";
    };
    Blockly.PythonDebug.jmd_setInSound = function (a) {
        let frequency = a.getFieldValue("FREQUENCY");
        let time = Blockly.PythonDebug.valueToCode(a, "TIME", 2);
        return "rcu.SetInSound(" + frequency + ",(" + time + ")*1000)\r\n";
    };
    Blockly.PythonDebug.jmd_getData = function (a) {
        return ["rcu.GetData(" + Blockly.PythonDebug.valueToCode(a, "ADDRESS", 16) + ")", 1, ];
    };
    Blockly.PythonDebug.jmd_setData = function (a) {
        let address = Blockly.PythonDebug.valueToCode(a, "ADDRESS", 16);
        let value = Blockly.PythonDebug.valueToCode(a, "VALUE", 16);
        return "rcu.SetData(" + address + "," + value + ")\r\n";
    };




    //马达

    Blockly.PythonDebug.motor_setMotor = function (a, b, c) {
        let motorport = a.getFieldValue("MOTORPORT");
        let value = Blockly.PythonDebug.valueToCode(a, "VALUE", 16);
        return "rcu.SetMotor(" + motorport + "," + value + ")\r\n";
    };
    Blockly.PythonDebug.motor_getMotorCode = function (a, b, c) {
        let motorport = a.getFieldValue("MOTORPORT");
        return ["rcu.GetMotorCode(" + motorport + ")", 1];
    };
    Blockly.PythonDebug.motor_setMotorCode = function (a, b, c) {
        let motorport = a.getFieldValue("MOTORPORT");
        return "rcu.SetMotorCode(" + motorport + ")\r\n";
    };
    Blockly.PythonDebug.motor_setServoMotor = function (a, b, c) {
        let motorport = a.getFieldValue("PORT");
        let speed = Blockly.PythonDebug.valueToCode(a, "SPEED", 16);
        let angle = Blockly.PythonDebug.valueToCode(a, "ANGLE", 16);
        return "rcu.SetMotorServo(" + motorport + "," + speed + "," + angle + ")\r\n";
    };
    Blockly.PythonDebug.motor_waitServomotor = function (a, b, c) {
        let motorport = a.getFieldValue("PORT");
        let speed = Blockly.PythonDebug.valueToCode(a, "SPEED", 16);
        let angle = Blockly.PythonDebug.valueToCode(a, "ANGLE", 16);
        return "rcu.SetWaitForAngle(" + motorport + "," + speed + "," + angle + ")\r\n";
    };
    Blockly.PythonDebug.motor_setLinearSpeed = function (a, b, c) {
        let motorport1 = a.getFieldValue("PORT1");
        let motorport2 = a.getFieldValue("PORT2");
        let speed = Blockly.PythonDebug.valueToCode(a, "SPEED", 16);
        let pulse = Blockly.PythonDebug.valueToCode(a, "PULSE", 16);
        return "rcu.SetMotorStraightAngle(" + motorport1 + "," + motorport2 + "," + speed + "," + pulse + ")\r\n";
    };
    Blockly.PythonDebug.motor_setTurnSpeed = function (a, b, c) {
        let motorport1 = a.getFieldValue("PORT1");
        let motorport2 = a.getFieldValue("PORT2");
        let speed = Blockly.PythonDebug.valueToCode(a, "SPEED", 16);
        let pulse = Blockly.PythonDebug.valueToCode(a, "PULSE", 16);
        return "rcu.SetCarTurn(" + motorport1 + "," + motorport2 + "," + speed + "," + pulse + ")\r\n";
    };
    Blockly.PythonDebug.motor_setMotorPower = function (a, b, c) {
        let motorone = Blockly.PythonDebug.valueToCode(a, "MOTORONE", 16);
        let motortwo = Blockly.PythonDebug.valueToCode(a, "MOTORTWO", 16);
        let motorthree = Blockly.PythonDebug.valueToCode(a, "MOTORTHREE", 16);
        let motorfour = Blockly.PythonDebug.valueToCode(a, "MOTORFOUR", 16);
        return "rcu.SetMotorPower(" + motorone + "," + motortwo + "," + motorthree + "," + motorfour + ")\r\n";
    };
    Blockly.PythonDebug.motor_setMotorStraight = function (a, b, c) {
        let motorport1 = a.getFieldValue("MOTORPORTONE");
        let motorport2 = a.getFieldValue("MOTORPORTTWO");
        let speed = Blockly.PythonDebug.valueToCode(a, "SPEED", 16);
        return "rcu.SetMotorStraight(" + motorport1 + "," + motorport2 + "," + speed + ")\r\n";
    };
    Blockly.PythonDebug.motor_setMotorStraightTurn = function (a, b, c) {
        let motorport1 = a.getFieldValue("MOTORPORTONE");
        let motorport2 = a.getFieldValue("MOTORPORTTWO");
        let speed = Blockly.PythonDebug.valueToCode(a, "SPEED", 16);
        let angle = Blockly.PythonDebug.valueToCode(a, "ANGLE", 16);
        return "rcu.SetMotorStraightTurn(" + motorport1 + "," + motorport2 + "," + speed + "," + angle + ")\r\n";
    };
    Blockly.PythonDebug.motor_setServo = function (a, b, c) {
        let prop = a.getFieldValue("PROP");
        let angle = Blockly.PythonDebug.valueToCode(a, "ANGLE", 16);
        return "rcu.SetServo(" + prop + "," + angle + ")\r\n";
    };
    Blockly.PythonDebug.motor_setServoTime = function (a, b, c) {
        let prop = a.getFieldValue("PROP");
        let angle = Blockly.PythonDebug.valueToCode(a, "ANGLE", 16);
        let time = Blockly.PythonDebug.valueToCode(a, "TIME", 16);
        return "rcu.SetServoTime(" + prop + "," + angle + "," + time + ")\r\n";
    };
    Blockly.PythonDebug.motor_setServo_E6 = function (a, b, c) {
        let prop = a.getFieldValue("PORT");
        let angle = Blockly.PythonDebug.valueToCode(a, "ANGLE", 16);
        return "rcu.SetServo(" + prop + "," + angle + ")\r\n";
    };
    Blockly.PythonDebug.motor_setServoTime_E6 = function (a, b, c) {
        let prop = a.getFieldValue("PORT");
        let angle = Blockly.PythonDebug.valueToCode(a, "ANGLE", 16);
        let time = Blockly.PythonDebug.valueToCode(a, "TIME", 16);
        return "rcu.SetServoTime(" + prop + "," + angle + "," + time + ")\r\n";
    };
    Blockly.PythonDebug.motor_setOneServo = function (a, b, c) {
        let prop = a.getFieldValue("PORT");
        let channel = Blockly.PythonDebug.valueToCode(a, "CHANNEL", 16);
        let angle = Blockly.PythonDebug.valueToCode(a, "ANGLE", 16);
        let time = Blockly.PythonDebug.valueToCode(a, "TIME", 16);
        return "rcu.SetOneServo(" + prop + "," + channel + "," + angle + "," + time + ");\r\n";
    };


    //M6 RCU 马达特有的积木块

    Blockly.PythonDebug.motor_setServoMotor48 = function (a, b, c) {
        let prop = a.getFieldValue("PORT");
        let speed = Blockly.PythonDebug.valueToCode(a, "SPEED", 16);
        let angle = Blockly.PythonDebug.valueToCode(a, "ANGLE", 16);
        return "rcu.SetMotorServo48(" + prop + "," + speed + "," + angle + ")\r\n";
    };

    Blockly.PythonDebug.motor_waitServomotor48 = function (a, b, c) {
        let prop = a.getFieldValue("PORT");
        let speed = Blockly.PythonDebug.valueToCode(a, "SPEED", 16);
        let angle = Blockly.PythonDebug.valueToCode(a, "ANGLE", 16);
        return "rcu.SetWaitForAngle48(" + prop + "," + speed + "," + angle + ")\r\n";
    };

    Blockly.PythonDebug.motor_setServoMotor128 = function (a, b, c) {
        let prop = a.getFieldValue("PORT");
        let speed = Blockly.PythonDebug.valueToCode(a, "SPEED", 16);
        let angle = Blockly.PythonDebug.valueToCode(a, "ANGLE", 16);
        return "rcu.SetMotorServo128(" + prop + "," + speed + "," + angle + ")\r\n";
    };

    Blockly.PythonDebug.motor_waitservomotor128 = function (a, b, c) {
        let prop = a.getFieldValue("PORT");
        let speed = Blockly.PythonDebug.valueToCode(a, "SPEED", 16);
        let angle = Blockly.PythonDebug.valueToCode(a, "ANGLE", 16);
        return "rcu.SetWaitForAngle128(" + prop + "," + speed + "," + angle + ")\r\n";
    };
    Blockly.PythonDebug.motor_setServo_M6 = function (a, b, c) {
        let prop = a.getFieldValue("PORT");
        let angle = Blockly.PythonDebug.valueToCode(a, "ANGLE", 16);
        return "rcu.SetServo(" + prop + "," + angle + ")\r\n";
    };
    Blockly.PythonDebug.motor_setServoTime_M6 = function (a, b, c) {
        let prop = a.getFieldValue("PORT");
        let angle = Blockly.PythonDebug.valueToCode(a, "ANGLE", 16);
        let time = Blockly.PythonDebug.valueToCode(a, "TIME", 16);
        return "rcu.SetServoTime(" + prop + "," + angle + "," + time + ")\r\n";
    };



    //控制
    Blockly.PythonDebug.math_positive_number = function (a) {
        let num = a.getFieldValue('NUM');
        return [num, 1];
    };
    Blockly.PythonDebug.control_wait = function (a) {
        let time = Blockly.PythonDebug.valueToCode(a, "DURATION", 16);
        return "rcu.SetWaitForTime(" + time + ")\r\n";
    };
    Blockly.PythonDebug.control_repeat = function (block) {
        let time = Blockly.PythonDebug.valueToCode(block, "TIMES", 16);
        let branch = Blockly.PythonDebug.statementToCode(block, "SUBSTACK");
        branch = branch ? (Blockly.PythonDebug.addLoopTrap(branch, branch) || Blockly.PythonDebug.pass) : Blockly.PythonDebug.pass;
        return "for count in range(" + time + "):\r\n" + branch + "\b";
    };
    Blockly.PythonDebug.control_forever = function (block) {
        let branch = Blockly.PythonDebug.statementToCode(block, "SUBSTACK");
        branch = Blockly.PythonDebug.addLoopTrap(branch, branch) || Blockly.PythonDebug.pass;
        return "while True:\r\n" + branch + "\b";
    };
    Blockly.PythonDebug.control_if = function (block) {
        let bool = Blockly.PythonDebug.valueToCode(block, "CONDITION", 1);
        if (bool === "") {
            bool = "FALSE";
        }
        let branch = Blockly.PythonDebug.statementToCode(block, "SUBSTACK");
        branch = Blockly.PythonDebug.addLoopTrap(branch, branch) || Blockly.PythonDebug.pass;
        return "if " + bool + ":\r\n" + branch + "\b";
    };
    Blockly.PythonDebug.control_if_else = function (block) {
        let bool = Blockly.PythonDebug.valueToCode(block, "CONDITION", 2);
        if (bool === "") {
            bool = "FALSE";
        }
        let branch1 = Blockly.PythonDebug.statementToCode(block, "SUBSTACK", 2);
        branch1 = Blockly.PythonDebug.addLoopTrap(branch1, branch1) || Blockly.PythonDebug.pass;
        let branch2 = Blockly.PythonDebug.statementToCode(block, "SUBSTACK2");
        branch2 = Blockly.PythonDebug.addLoopTrap(branch2, branch2) || Blockly.PythonDebug.pass;
        return "if " + bool + ":\r\n" + branch1 + "\belse:\r\n" + branch2 + "\b";
    };
    Blockly.PythonDebug.control_wait_until = function (block) {
        let bool = Blockly.PythonDebug.valueToCode(block, "CONDITION", 16);
        return "while not(" + bool + "):\r\npass\b\r\n";
    };
    Blockly.PythonDebug.control_repeat_until = function (block) {
        let bool = Blockly.PythonDebug.valueToCode(block, "CONDITION", 16);
        let branch = Blockly.PythonDebug.statementToCode(block, "SUBSTACK");
        branch = Blockly.PythonDebug.addLoopTrap(branch, branch) || Blockly.PythonDebug.pass;
        return "while not(" + bool + "):\r\n" + branch + "\b";
    };


    //传感器

    Blockly.PythonDebug.sensor_getTouch = function (a) {
        let prop = a.getFieldValue("SENSORPORT");
        return ["rcu.GetTouch(" + prop + ")", 1];
    };
    Blockly.PythonDebug.sensor_colorDetection = function (a) {
        let prop = a.getFieldValue("COLORPORT");
        return ["rcu.GetColorSensor(" + prop + ",4)", 1];
    };
    Blockly.PythonDebug.sensor_getUltrasonic = function (a) {
        let prop = a.getFieldValue("ULTRASONICPORT");
        return ["rcu.GetUltrasound(" + prop + ")", 1];
    };
    Blockly.PythonDebug.sensor_getLightSensor = function (a) {
        let prop = a.getFieldValue("SENSORPORT");
        return ["rcu.GetLightSensor(" + prop + ")", 1];
    };
    Blockly.PythonDebug.sensor_getLightSensorDigital = function (a) {
        let prop = a.getFieldValue("SENSORPORT");
        return ["rcu.GetLightSensorData(" + prop + ")", 1];
    };
    Blockly.PythonDebug.sensor_setLightSensor = function (a) {
        let prop = a.getFieldValue("SENSORPORT");
        let state = a.getFieldValue("STATE");
        return "rcu.SetLightSensorLed(" + prop + "," + state + ")\r\n";
    };
    Blockly.PythonDebug.sensor_setColorLamp = function (a) {
        let prop = a.getFieldValue("SENSORPORT");
        let color = a.getFieldValue("COLOR");
        return "rcu.Set3CLed(" + prop + "," + color + ")\r\n";
    };
    Blockly.PythonDebug.sensor_getgesture = function (a) {
        let prop = a.getFieldValue("PORT");
        return ["rcu.GetGesture(" + prop + ")", 1];
    };
    Blockly.PythonDebug.sensor_getWifiCamRockCtrlNew = function (a) {
        let rockctrl = a.getFieldValue("ROCKCTRL");
        return ["rcu.GetWifiCamRockCtrlNew(" + rockctrl + ")", 1];
    };
    Blockly.PythonDebug.sensor_getWifiPictureData = function (a) {
        let rockctrl = a.getFieldValue("PICTURE");
        return ["rcu.GetWifiPictureData(" + rockctrl + ")", 1];
    };
    Blockly.PythonDebug.sensor_getCamRecogData = function (a) {
        let data = Blockly.PythonDebug.valueToCode(a, "DATA", 16);
        return ["rcu.GetCamRecog(" + data + ")", 1];
    };
    Blockly.PythonDebug.sensor_getWifiCamPictureResult = function (a) {
        let camdata = a.getFieldValue("CAMDATA");
        return ["rcu.GetWifiCamPictureResult(" + camdata + ")", 1];
    };
    Blockly.PythonDebug.sensor_getWifiCamPictureSize = function (a) {
        let size = a.getFieldValue("SIZE");
        return ["rcu.GetWifiCamPictureSize(" + size + ")", 1];
    };
    Blockly.PythonDebug.sensor_getWifiCamPictureSite = function (a) {
        let site = a.getFieldValue("SITE");
        return ["rcu.GetWifiCamPictureSite(" + site + ")", 1];
    };
    Blockly.PythonDebug.sensor_setLizard = function (a) {
        let color = a.getFieldValue("COLOR");
        return "rcu.SetLizard(" + color + ")\r\n";
    };
    Blockly.PythonDebug.sensor_getRFID = function (a) {
        let port = a.getFieldValue("SENSORPORT");
        return ["rcu.GetRFID522(" + port + ")", 1];
    };
    Blockly.PythonDebug.sensor_ReadRFIDData = function (a) {
        let port = a.getFieldValue("SENSORPORT");
        return ["rcu.ReadRFID522(" + port + ")", 1];
    };

    Blockly.PythonDebug.sensor_WriteRFIDData = function (a) {
        let port = a.getFieldValue("SENSORPORT");
        let data = Blockly.PythonDebug.valueToCode(a, "DATA", 16)
        return "rcu.WriteRFID522(" + port + "," + data + ")\r\n";
    };

    // M6 RCU 传感器特有的积木块

    Blockly.PythonDebug.sensor_getRFID2 = function (a) {
        let port = a.getFieldValue("SENSORPORT");
        return ["rcu.GetRFID522(" + port + ")", 1];
    };
    Blockly.PythonDebug.sensor_ReadRFIDData2 = function (a) {
        let port = a.getFieldValue("SENSORPORT");
        return ["rcu.ReadRFID522(" + port + ")", 1];
    };
    Blockly.PythonDebug.sensor_WriteRFIDData2 = function (a) {
        let port = a.getFieldValue("SENSORPORT");
        let data = Blockly.PythonDebug.valueToCode(a, "DATA", 16)
        return "rcu.WriteRFID522(" + port + "," + data + ")\r\n";
    };




    //AI

    Blockly.PythonDebug.sensor_setAICamData = function (a) {
        let aimode = a.getFieldValue("AIMODE");
        let aimode2 = a.getFieldValue("AIMODE2") ? a.getFieldValue("AIMODE2") : 0;
        return "rcu.SetWaitForAICamData(" + aimode + "," + aimode2 + ")\r\n";
    };
    Blockly.PythonDebug.sensor_getAICamData = function (a) {
        let data = a.getFieldValue("DATA");
        return ["rcu.GetAICamData(" + data + ")", 1];
    };
    Blockly.PythonDebug.sensor_setWaitForAICamData = function (a) {
        let aimode = a.getFieldValue("AIMODE");
        let aimode2 = a.getFieldValue("AIMODE2") ? a.getFieldValue("AIMODE2") : 0;
        return "rcu.SetWaitForAICamData(" + aimode + "," + aimode2 + ")\r\n";
    };
    Blockly.PythonDebug.sensor_getAICamDataColorDetect = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.PythonDebug.sensor_getAICamDataQR = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.PythonDebug.sensor_getAICamDataBall = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.PythonDebug.sensor_getAICamDataRoad = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.PythonDebug.sensor_getAICamDataFaceDetect = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.PythonDebug.sensor_getAICamDataImage = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.PythonDebug.sensor_getAICamDataImageLearning = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.PythonDebug.sensor_getAICamDataGesture = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.PythonDebug.sensor_getAICamDataApriltag = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.PythonDebug.sensor_getAICamDataTraffic = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.PythonDebug.sensor_getAICamDataColorLearning = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.PythonDebug.sensor_getAICamDataFaceLearning = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.PythonDebug.sensor_getAICamVoice = function (a) {
        let order = a.getFieldValue("ORDER");
        return ["rcu.GetAICamVoice(" + order + ")", 1];
    };
    Blockly.PythonDebug.sensor_getAIBrainData = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.PythonDebug.sensor_getAICamDataForest = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.PythonDebug.sensor_getAICamDataLeftWidth = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.PythonDebug.sensor_getAICamDataRightWidth = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };



    //显示

    Blockly.PythonDebug.show_getTouchScreen = function (a) {
        return ["rcu.GetTouchScreen()", 1];
    };
    Blockly.PythonDebug.show_getTouchScreenX = function (a) {
        return ["rcu.GetTouchScreenX()", 1];
    };
    Blockly.PythonDebug.show_getTouchScreenY = function (a) {
        return ["rcu.GetTouchScreenY()", 1];
    };
    Blockly.PythonDebug.show_LCDClearScreen = function (a) {
        let color = a.getFieldValue("COLOR");
        return "rcu.SetLCDClear(" + color + ")\r\n";
    };
    Blockly.PythonDebug.show_SetFontSize = function (a) {
        let fontsize = a.getFieldValue("FONTSIZE");
        return "rcu.SetFontSize(" + fontsize + ")\r\n";
    };
    Blockly.PythonDebug.show_setLineNum = function (a) {
        let lines = Blockly.PythonDebug.valueToCode(a, "LINES", 16);
        let linenumber = Blockly.PythonDebug.valueToCode(a, "LINENUMBER", 16);
        return "rcu.SetDisplayVar(" + lines + "," + linenumber + ",0xFFE0,0x0000)\r\n";
    };
    Blockly.PythonDebug.show_setColor = function (a) {
        let lines = Blockly.PythonDebug.valueToCode(a, "LINES", 16);
        let text = Blockly.PythonDebug.valueToCode(a, "TEXT", 16);

        text = Blockly.PythonDebug.blockToCode(a.getInputTargetBlock("TEXT"))[1] == 3 ? text : "str(" + text + ")"

        return "rcu.SetDisplayString(" + lines + "," + text + ",0xFFE0,0x0000)\r\n";
    };
    Blockly.PythonDebug.show_drawImage = function (a) {
        let x = Blockly.PythonDebug.valueToCode(a, "IMAGEX", 16);
        let y = Blockly.PythonDebug.valueToCode(a, "IMAGEY", 16);
        let filename = Blockly.PythonDebug.valueToCode(a, "IMAGEFILENAME", 16);
        let scale = Blockly.PythonDebug.valueToCode(a, "IMAGESCALE", 16);
        return "rcu.SetDisplayPicture(" + x + "," + y + "," + filename + "," + scale + ")\r\n";
    };
    Blockly.PythonDebug.show_diplayData = function (a) {
        let x = Blockly.PythonDebug.valueToCode(a, "X", 16);
        let y = Blockly.PythonDebug.valueToCode(a, "Y", 16);
        let data = Blockly.PythonDebug.valueToCode(a, "DATA", 16);
        let color = a.getFieldValue("COLOR");
        let backgroundcolor = a.getFieldValue("BACKGROUNDCOLOR");
        return "rcu.SetDisplayVarXY(" + x + "," + y + "," + data + "," + color + "," + backgroundcolor + ")\r\n";
    };
    Blockly.PythonDebug.show_displayCharacter = function (a) {
        let x = Blockly.PythonDebug.valueToCode(a, "X", 16);
        let y = Blockly.PythonDebug.valueToCode(a, "Y", 16);

        let text = Blockly.PythonDebug.valueToCode(a, "CHARACTER", 16);
        text = Blockly.PythonDebug.blockToCode(a.getInputTargetBlock("CHARACTER"))[1] == 3 ? text : "str(" + text + ")"

        let color = a.getFieldValue("COLOR");
        let backgroundcolor = a.getFieldValue("BACKGROUNDCOLOR");
        let transparent = a.getFieldValue("TRANSPARENT");
        return "rcu.SetDisplayStringXY(" + x + "," + y + "," + text + "," + color + "," + backgroundcolor + "," + transparent + ")\r\n";
    };
    Blockly.PythonDebug.show_drawPoint = function (a) {
        let x = Blockly.PythonDebug.valueToCode(a, "POINTX", 16);
        let y = Blockly.PythonDebug.valueToCode(a, "POINTY", 16);
        let color = a.getFieldValue("POINTCOLOR");
        return "rcu.SetLCDDot(" + x + "," + y + "," + color + ")\r\n";
    };
    Blockly.PythonDebug.show_drawLine = function (a) {
        let x = Blockly.PythonDebug.valueToCode(a, "LINEX", 16);
        let y = Blockly.PythonDebug.valueToCode(a, "LINEY", 16);
        let lineangle = Blockly.PythonDebug.valueToCode(a, "LINEANGLE", 16);
        let linelength = Blockly.PythonDebug.valueToCode(a, "LINELENGTH", 16);
        let color = a.getFieldValue("LINECOLOR");
        return "rcu.SetLCDLine(" + x + "," + y + "," + lineangle + "," + linelength + "," + color + ")\r\n";
    };
    Blockly.PythonDebug.show_drawCircle = function (a) {
        let x = Blockly.PythonDebug.valueToCode(a, "CIRCLEX", 16);
        let y = Blockly.PythonDebug.valueToCode(a, "CIRCLEY", 16);
        let circleradius = Blockly.PythonDebug.valueToCode(a, "CIRCLERADIUS", 16);
        let color = a.getFieldValue("CIRCLECOLOR");
        return "rcu.SetLCDSolidCircle(" + x + "," + y + "," + circleradius + "," + color + ")\r\n";
    };
    Blockly.PythonDebug.show_drawRectangle = function (a) {
        let x = Blockly.PythonDebug.valueToCode(a, "RECTANGLEX", 16);
        let y = Blockly.PythonDebug.valueToCode(a, "RECTANGLEY", 16);
        let rectanglewitdh = Blockly.PythonDebug.valueToCode(a, "RECTANGLEWIDTH", 16);
        let rectangleheight = Blockly.PythonDebug.valueToCode(a, "RECTANGLEHEIGHT", 16);
        let rectanglelinewidth = Blockly.PythonDebug.valueToCode(a, "RECTANGLELINEWIDTH", 16);
        let color = a.getFieldValue("RECTANGLECOLOR");
        return "rcu.SetLCDRectangle2(" + x + "," + y + "," + rectanglewitdh + "," + rectangleheight + "," + rectanglelinewidth + "," + color + ")\r\n";
    };
    Blockly.PythonDebug.show_drawSolidRectangle = function (a) {
        let x = Blockly.PythonDebug.valueToCode(a, "SOLIDRECTANGLEX", 16);
        let y = Blockly.PythonDebug.valueToCode(a, "SOLIDRECTANGLEY", 16);
        let solidrectanglewidth = Blockly.PythonDebug.valueToCode(a, "SOLIDRECTANGLEWIDTH", 16);
        let solidrectangleheight = Blockly.PythonDebug.valueToCode(a, "SOLIDRECTANGLEHEIGHT", 16);
        let color = a.getFieldValue("SOLIDRECTANGLECOLOR");
        return "rcu.SetLCDFilledRectangle2(" + x + "," + y + "," + solidrectanglewidth + "," + solidrectangleheight + "," + color + ")\r\n";
    };



    //播放

    Blockly.PythonDebug.play_playMP3 = function (a) {
        let foldername = Blockly.PythonDebug.valueToCode(a, "FOLDERNAME", 16);
        let musicname = Blockly.PythonDebug.valueToCode(a, "MUSICNAME", 16);
        foldername = foldername.replace(/'|"/gi, "");
        musicname = musicname.replace(/'|"/gi, "");
        return "rcu.SetMp3Play(" + foldername + "," + musicname + ")\r\n";
    };
    Blockly.PythonDebug.play_pausePlayback = function (a) {
        return "rcu.SetMp3Suspend()\r\n";
    };
    Blockly.PythonDebug.play_playSound = function (a) {
        let sound = a.getFieldValue("SOUND");
        return "rcu.SetMp3Play(1, " + sound + ")\r\n";
    };



    //无线
    Blockly.PythonDebug.wireless_getRCUBleData = function (a) {
        return ["rcu.GetBluetoothData()", 1];
    };
    Blockly.PythonDebug.wireless_RCUSendBluetoothData = function (a) {
        let data = Blockly.PythonDebug.valueToCode(a, "DATA", 16);
        return "rcu.SetBluetoothData(" + data + ")\r\n";
    };
    Blockly.PythonDebug.wireless_getComVoice = function (a) {
        let text = Blockly.PythonDebug.valueToCode(a, "TEXT", 16);
        return ["rcu.GetComVoice(" + text + ")", 1];
    };
    Blockly.PythonDebug.wireless_getBluetoothControl = function (a) {
        return ["rcu.GetBluetoothControl()", 1];
    };
    Blockly.PythonDebug.wireless_getBluetoothControlData = function (a) {
        return ["rcu.GetBluetoothControlData()", 1];
    };
    Blockly.PythonDebug.wireless_getBluetoothButton = function (a) {
        return ["rcu.GetBTModuleRemoteButton()", 1];
    };
    Blockly.PythonDebug.wireless_getBluetoothCode = function (a) {
        return ["rcu.GetBTModuleRemoteCode()", 1];
    };
    Blockly.PythonDebug.wireless_getBluetoothRocker = function (a) {
        let direction = a.getFieldValue("DIRECTION");
        let axis = a.getFieldValue("AXIS");
        return ["rcu.GetBTModuleRemoteRocker(" + direction + "," + axis + ")", 1];
    };



    // 扩展： 传感器
    Blockly.PythonDebug.extSensor_setAttitude = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("SETATTITUDEMODE");
        return "rcu.SetAHRS(" + arg1 + "," + arg2 + ")\r\n";
    };
    Blockly.PythonDebug.extSensor_getAttitude = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("ATTITUDEMODE");
        return ["rcu.GetAHRS(" + arg1 + "," + arg2 + ")", 1];
    };

    Blockly.PythonDebug.extSensor_LaserDist = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("LASERDISTMODE");
        return ["rcu.GetLaserDist(" + arg1 + "," + arg2 + ")", 1];
    };
    Blockly.PythonDebug.extSensor_ShortIRDist = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        return ["rcu.GetShortIRDist(" + arg1 + ")", 1];
    };
    Blockly.PythonDebug.extSensor_Gesture = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        return ["rcu.GetGesture(" + arg1 + ")", 1];
    };
    Blockly.PythonDebug.extSensor_sensor_getAirPressure = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        return ["rcu.GetAirPressure(" + arg1 + ")", 1];
    };
    Blockly.PythonDebug.extSensor_sensor_getSht30 = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("COMMAND");
        return ["rcu.GetSht30(" + arg1 + "," + arg2 + ")", 1];
    };
    Blockly.PythonDebug.extSensor_sensor_getMagnetic = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("MODEL");
        return ["rcu.GetMagnetic(" + arg1 + "," + arg2 + ")", 1];
    };
    Blockly.PythonDebug.extSensor_sensor_getScanCamera = function (a) {
        return ["rcu.GetScanCamera()", 1];
    };
    Blockly.PythonDebug.extSensor_sensor_getComStrCompare = function (a) {
        let value = Blockly.PythonDebug.valueToCode(a, "VALUE", 2);
        return [`rcu.GetComStrCompare(${value})`, 1];
    };
    Blockly.PythonDebug.extSensor_smartEyeDist = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        return ["rcu.GetSmartEyeDist(" + arg1 + ")", 1];
    };
    Blockly.PythonDebug.extSensor_smartEyeIRCode = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        return ["rcu.GetSmartEyeIRcode(" + arg1 + ")", 1];
    };
    Blockly.PythonDebug.extSensor_setSmartEyeIRCode = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = Blockly.PythonDebug.valueToCode(a, "VALUE", 16);
        return "rcu.SetSmartEyeIRcode(" + arg1 + "," + arg2 + ");\r\n";
    };
    Blockly.PythonDebug.extSensor_setSmartEye = function (a) {

        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("SMARTEYEMODE");

        let arg3 = Blockly.PythonDebug.valueToCode(a, "COLOR", 16);
        arg3 = Blockly.PythonDebug.transformColor(arg3) //转换成 0x的形式

        return "rcu.SetSmartEyeMode(" + arg1 + "," + arg2 + "," + arg3 + ");\r\n";
    };
    Blockly.PythonDebug.extSensor_setSmartEyeAllLed = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");

        let arg2 = Blockly.PythonDebug.valueToCode(a, "COLOR1", 16);
        arg2 = Blockly.PythonDebug.transformColor(arg2) //转换成 0x的形式

        let arg3 = Blockly.PythonDebug.valueToCode(a, "COLOR2", 16);
        arg3 = Blockly.PythonDebug.transformColor(arg3) //转换成 0x的形式

        let arg4 = Blockly.PythonDebug.valueToCode(a, "COLOR3", 16);
        arg4 = Blockly.PythonDebug.transformColor(arg4) //转换成 0x的形式

        let arg5 = Blockly.PythonDebug.valueToCode(a, "COLOR4", 16);
        arg5 = Blockly.PythonDebug.transformColor(arg5) //转换成 0x的形式

        let arg6 = Blockly.PythonDebug.valueToCode(a, "COLOR5", 16);
        arg6 = Blockly.PythonDebug.transformColor(arg6) //转换成 0x的形式

        let arg7 = Blockly.PythonDebug.valueToCode(a, "COLOR6", 16);
        arg7 = Blockly.PythonDebug.transformColor(arg7) //转换成 0x的形式

        let arg8 = Blockly.PythonDebug.valueToCode(a, "COLOR7", 16);
        arg8 = Blockly.PythonDebug.transformColor(arg8) //转换成 0x的形式

        let arg9 = Blockly.PythonDebug.valueToCode(a, "COLOR8", 16);
        arg9 = Blockly.PythonDebug.transformColor(arg9) //转换成 0x的形式

        return "rcu.SetSmartEyeAllLed(" + arg1 + "," + arg2 + "," + arg3 + "," + arg4 + "," + arg5 + "," + arg6 + "," + arg7 + "," + arg8 + "," + arg9 + ");\r\n";
    };
    Blockly.PythonDebug.extSensor_SetDisplayLatticeClear = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        return "rcu.SetDisplayLatticeClear(" + arg1 + ");\r\n";
    };
    Blockly.PythonDebug.extSensor_SetDisplayLatticePic = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");

        let arg2 = Blockly.PythonDebug.valueToCode(a, "MATRIX", 16);
        arg2 = '"' + Blockly.PythonDebug.matrixToString16(arg2) + '"'

        let arg3 = a.getFieldValue("LIGHTNESS");

        return "rcu.SetDisplayLatticePic(" + arg1 + "," + arg2 + "," + arg3 + ");\r\n";
    };
    Blockly.PythonDebug.extSensor_SetDisplayLattice = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");

        let arg2 = Blockly.PythonDebug.valueToCode(a, "VALUE", 16);
        arg2 = Blockly.PythonDebug.blockToCode(a.getInputTargetBlock("VALUE"))[1] == 3 ? arg2 : "str(" + arg2 + ")"

        let arg3 = a.getFieldValue("LIGHTNESS");
        return "rcu.SetDisplayLattice(" + arg1 + "," + arg2 + "," + arg3 + ");\r\n";
    };
    Blockly.PythonDebug.extSensor_SetDisplayLatticeXY = function (a) {

        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = Blockly.PythonDebug.valueToCode(a, "X", 16);
        let arg3 = Blockly.PythonDebug.valueToCode(a, "Y", 16);
        let arg4 = a.getFieldValue("STATES");
        let arg5 = a.getFieldValue("LIGHTNESS");

        return "rcu.SetDisplayLatticeXY(" + arg1 + "," + arg2 + "," + arg3 + "," + arg4 + "," + arg5 + ");\r\n";
    };
    Blockly.PythonDebug.extSensor_SetDisplayLatticeString = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");

        let arg2 = Blockly.PythonDebug.valueToCode(a, "STRING", 16);
        arg2 = Blockly.PythonDebug.blockToCode(a.getInputTargetBlock("STRING"))[1] == 3 ? arg2 : "str(" + arg2 + ")"

        let arg3 = a.getFieldValue("DIRECTION");
        let arg4 = Blockly.PythonDebug.valueToCode(a, "SPEED", 16);
        let arg5 = a.getFieldValue("LIGHTNESS");

        return "rcu.SetDisplayLatticeString(" + arg1 + "," + arg2 + "," + arg3 + "," + arg4 + "," + arg5 + ");\r\n";
    };


    // 扩展： AI

    Blockly.PythonDebug.AI_sensor_setWaitForAICamData = function (a) {
        let arg1 = a.getFieldValue("DATA");
        return "rcu.SetWaitForAICamData(" + arg1 + ",0);\r\n";
    };
    Blockly.PythonDebug.AI_sensor_setAICamData = function (a) {
        let arg1 = a.getFieldValue("DATA");
        return "rcu.SetAICamData(" + arg1 + ",0);\r\n";
    };
    Blockly.PythonDebug.AI_sensor_getAICamDataColorDetect = function (a) {
        let arg1 = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.PythonDebug.AI_sensor_getAICamDataQR = function (a) {
        let arg1 = a.getFieldValue("COLOR6");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.PythonDebug.AI_sensor_getAICamDataBall = function (a) {
        let arg1 = a.getFieldValue("COLOR2");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.PythonDebug.AI_sensor_getAICamDataRoad = function (a) {
        let arg1 = a.getFieldValue("COLOR5");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.PythonDebug.AI_sensor_getAICamDataFaceDetect = function (a) {
        let arg1 = a.getFieldValue("COLOR3");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.PythonDebug.AI_sensor_getAICamDataImage = function (a) {
        let arg1 = a.getFieldValue("COLOR7");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.PythonDebug.AI_sensor_getAICamDataApriltag = function (a) {
        let arg1 = a.getFieldValue("COLOR7");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.PythonDebug.AI_sensor_getAICamDataGesture = function (a) {
        let arg1 = a.getFieldValue("COLOR7");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.PythonDebug.AI_sensor_getAICamDataTraffic = function (a) {
        let arg1 = a.getFieldValue("COLOR7");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.PythonDebug.AI_sensor_getAICamDataColorLearning = function (a) {
        let arg1 = a.getFieldValue("COLOR1");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.PythonDebug.AI_sensor_getAICamDataFaceLearning = function (a) {
        let arg1 = a.getFieldValue("COLOR4");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.PythonDebug.AI_sensor_getAICamDataImageStudy = function (a) {
        let arg1 = a.getFieldValue("COLOR7");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.PythonDebug.AI_sensor_getAICamData = function (a) {
        let arg1 = a.getFieldValue("DATA1");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.PythonDebug.AI_sensor_getAICamVoice = function (a) {
        let arg1 = a.getFieldValue("ORDER");
        return ["rcu.GetAICamVoice(" + arg1 + ")", 1];
    };
    Blockly.PythonDebug.AI_sensor_setFaceRegister = function (a) {
        let arg1 = Blockly.PythonDebug.valueToCode(a, "ID", 16);
        return "rcu.SetFaceRegister(" + arg1 + ");\r\n"
    };
    Blockly.PythonDebug.AI_sensor_getFaceRegisterData = function (a) {
        let arg1 = Blockly.PythonDebug.valueToCode(a, "ID", 16);
        return ["rcu.GetFaceRegisterData(" + arg1 + ")", 1];
    };


    // 无线扩展

    Blockly.PythonDebug.extWireless_setRFPassWord = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = Blockly.PythonDebug.valueToCode(a, "DATA", 16);
        return `rcu.SetRFPassWord(${arg1}, ${arg2});\r\n`;
    };
    Blockly.PythonDebug.extWireless_setRFModuleByte = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = Blockly.PythonDebug.valueToCode(a, "DATA", 16);
        return `rcu.SetRFModuleByte(${arg1}, ${arg2});\r\n`;
    };
    Blockly.PythonDebug.extWireless_getRFModuleByte = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        return [`rcu.GetRFModuleByte(${arg1})`, 1];
    };
    Blockly.PythonDebug.extWireless_getRFModuleRemoteButton = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        return [`rcu.GetRFModuleRemoteButton(${arg1})`, 1];
    };
    Blockly.PythonDebug.extWireless_getRFModuleRemoteCode = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        return [`rcu.GetRFModuleRemoteCode(${arg1})`, 1];
    };
    Blockly.PythonDebug.extWireless_getRFModuleRemoteGravity = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("AXIS");
        return [`rcu.GetRFModuleRemoteGravity(${arg1}, ${arg2})`, 1];
    };
    Blockly.PythonDebug.extWireless_getRFModuleRemoteRocker = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("DIRECTION");
        let arg3 = a.getFieldValue("AXIS");
        return [`rcu.GetRFModuleRemoteRocker(${arg1}, ${arg2}, ${arg3})`, 1];
    };
    Blockly.PythonDebug.extWireless_getRFModuleRemoteBit = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("BTN");
        return [`rcu.GetRFModuleRemoteBit(${arg1}, ${arg2})`, 1];
    };




    //   列表
    Blockly.PythonDebug.data_listHead = "LIST_"
    Blockly.PythonDebug.data_listcontents = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';

        listname = Blockly.PythonDebug.data_listHead + listname

        return [listname, 1]
    };
    Blockly.PythonDebug.data_addtolist = function (a) {
        let str = Blockly.PythonDebug.valueToCode(a, "ITEM", 2)

        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.PythonDebug.data_listHead + listname

        return `${listname}.append(${str})\r\n`
    };

    Blockly.PythonDebug.data_deleteoflist = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.PythonDebug.data_listHead + listname

        let line = Blockly.PythonDebug.valueToCode(a, "INDEX", 2)

        if (isNaN(Number(line))) {
            let str = line.replace(/\(|\)/ig, "")
            if (isNaN(Number(str))) {
                line = line + " - 1"
            } else {
                line = Number(line) > 0 ? Number(line) - 1 : 0;
            }
        } else {
            line = Number(line) > 0 ? Number(line) - 1 : 0;
        }
        return `del ${listname}[${line}];\r\n`
    };

    Blockly.PythonDebug.data_deletealloflist = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.PythonDebug.data_listHead + listname
        return `del ${listname}[:]\r\n`
    };

    Blockly.PythonDebug.data_insertatlist = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.PythonDebug.data_listHead + listname

        let index = Blockly.PythonDebug.valueToCode(a, "INDEX", 2) - 1 || 0
        index = index < 0 ? 0 : index

        let item = Blockly.PythonDebug.valueToCode(a, "ITEM", 2)
        return `${listname}.insert(${index}, ${item});\r\n`
    };
    Blockly.PythonDebug.data_replaceitemoflist = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.PythonDebug.data_listHead + listname

        let index = Blockly.PythonDebug.valueToCode(a, "INDEX", 2) - 1 || 0
        index = index < 0 ? 0 : index

        let item = Blockly.PythonDebug.valueToCode(a, "ITEM", 2)
        return `${listname}[${index}] = ${item};\r\n`
    };

    Blockly.PythonDebug.data_listcontainsitem = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.PythonDebug.data_listHead + listname

        let str = Blockly.PythonDebug.valueToCode(a, "ITEM", 2)
        return [`${str} in ${listname}`, 1]
    };

    Blockly.PythonDebug.data_itemnumoflist = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.PythonDebug.data_listHead + listname

        let str = Blockly.PythonDebug.valueToCode(a, "ITEM", 2)
        return [`${listname}.index(${str})`, 1]
    };

    Blockly.PythonDebug.data_itemoflist = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.PythonDebug.data_listHead + listname

        let num = Blockly.PythonDebug.valueToCode(a, "INDEX", 2)

        if (isNaN(Number(num))) {
            let str = num.replace(/\(|\)/ig, "")
            if (isNaN(Number(str))) {
                num = num + " - 1"
            } else {
                num = Number(num) > 0 ? Number(num) - 1 : 0;
            }
        } else {
            num = Number(num) > 0 ? Number(num) - 1 : 0;
        }
        return [`${listname}[${num}]`, 1]
    };
    Blockly.PythonDebug.data_lengthoflist = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.PythonDebug.data_listHead + listname

        return [`len(${listname})`, 1]
    };



    //运算
    Blockly.PythonDebug.operator_add = function (a) {
        let NUM1 = Blockly.PythonDebug.valueToCode(a, "NUM1", 2) || 1
        let NUM2 = Blockly.PythonDebug.valueToCode(a, "NUM2", 2) || 1
        return [`${NUM1} + ${NUM2}`, 2]
    };
    Blockly.PythonDebug.operator_subtract = function (a) {
        let NUM1 = Blockly.PythonDebug.valueToCode(a, "NUM1", 2)
        let NUM2 = Blockly.PythonDebug.valueToCode(a, "NUM2", 2)
        return [`${NUM1} - ${NUM2}`, 2]
    };
    Blockly.PythonDebug.operator_multiply = function (a) {
        let NUM1 = Blockly.PythonDebug.valueToCode(a, "NUM1", 2)
        let NUM2 = Blockly.PythonDebug.valueToCode(a, "NUM2", 2)
        return [`${NUM1} * ${NUM2}`, 2]
    };
    Blockly.PythonDebug.operator_divide = function (a) {
        let NUM1 = Blockly.PythonDebug.valueToCode(a, "NUM1", 2)
        let NUM2 = Blockly.PythonDebug.valueToCode(a, "NUM2", 2)
        return [`${NUM1} / ${NUM2}`, 2]
    };
    Blockly.PythonDebug.math_arithmetic = function (a) {
        let RANDOMSTART = Blockly.PythonDebug.valueToCode(a, "A", 2)
        let OP = a.getFieldValue("OP")
        let RANDOMEND = Blockly.PythonDebug.valueToCode(a, "B", 2)
        return [`${RANDOMSTART} ${OP} ${RANDOMEND}`, 2]
    };
    Blockly.PythonDebug.operator_random = function (a) {
        let RANDOMSTART = Blockly.PythonDebug.valueToCode(a, "FROM", 2)
        let RANDOMEND = Blockly.PythonDebug.valueToCode(a, "TO", 2)
        return [`rcu.GetRandom(${RANDOMSTART},${RANDOMEND})`, 1]
    };
    Blockly.PythonDebug.operator_lt = function (a) {
        let OPERAND1 = Blockly.PythonDebug.valueToCode(a, "OPERAND1", 2)
        let OPERAND2 = Blockly.PythonDebug.valueToCode(a, "OPERAND2", 2)
        return [`${OPERAND1} < ${OPERAND2}`, 2]
    };
    Blockly.PythonDebug.operator_equals = function (a) {
        let OPERAND1 = Blockly.PythonDebug.valueToCode(a, "OPERAND1", 2)
        let OPERAND2 = Blockly.PythonDebug.valueToCode(a, "OPERAND2", 2)
        return [`${OPERAND1} == ${OPERAND2}`, 2]
    };
    Blockly.PythonDebug.operator_gt = function (a) {
        let OPERAND1 = Blockly.PythonDebug.valueToCode(a, "OPERAND1", 2)
        let OPERAND2 = Blockly.PythonDebug.valueToCode(a, "OPERAND2", 2)
        return [`${OPERAND1} > ${OPERAND2}`, 2]
    };
    Blockly.PythonDebug.operator_and = function (a) {
        let OPERAND1 = Blockly.PythonDebug.valueToCode(a, "OPERAND1", 2) || "()"
        let OPERAND2 = Blockly.PythonDebug.valueToCode(a, "OPERAND2", 2) || "()"
        return [`${OPERAND1} and ${OPERAND2}`, 2]
    };
    Blockly.PythonDebug.operator_or = function (a) {
        let OPERAND1 = Blockly.PythonDebug.valueToCode(a, "OPERAND1", 2) || "()"
        let OPERAND2 = Blockly.PythonDebug.valueToCode(a, "OPERAND2", 2) || "()"
        return [`${OPERAND1} or ${OPERAND2}`, 2]
    };
    Blockly.PythonDebug.operator_not = function (a) {
        let OPERAND = Blockly.PythonDebug.valueToCode(a, "OPERAND", 3)
        return [`not(${OPERAND})`, 1]
    };
    Blockly.PythonDebug.operator_mod = function (a) {
        let NUM1 = Blockly.PythonDebug.valueToCode(a, "NUM1", 2)
        let NUM2 = Blockly.PythonDebug.valueToCode(a, "NUM2", 2)
        return [`${NUM1} % ${NUM2}`, 2]
    };
    Blockly.PythonDebug.operator_round = function (a) {
        let NUM = Blockly.PythonDebug.valueToCode(a, "NUM", 3)
        return [`round(${NUM})`, 1]
    };
    Blockly.PythonDebug.operator_mathop = function (a) {
        Blockly.PythonDebug.definitions_.Math = "import math";
        let OPERATOR = a.getFieldValue("OPERATOR")
        let NUM = Blockly.PythonDebug.valueToCode(a, "NUM", 2)
        let str = ''
        if (OPERATOR === "e ^") {
            str = `math.pow(math.e,${NUM})`
        } else if (OPERATOR === "10 ^") {
            str = `math.pow(10,${NUM})`
        } else {
            str = `math.${OPERATOR}(${NUM})`
        }
        return [str, 1]
    };

    Blockly.PythonDebug.operator_join = function (a) {
        let string1 = Blockly.PythonDebug.valueToCode(a, "STRING1", 2)
        let string2 = Blockly.PythonDebug.valueToCode(a, "STRING2", 2)
        return [`${string1}.join(${string2})`, 1]
    };

    Blockly.PythonDebug.operator_letter_of = function (a) {
        let letter = Blockly.PythonDebug.valueToCode(a, "LETTER", 2)
        let string = Blockly.PythonDebug.valueToCode(a, "STRING", 2)
        return [`${string}.[${letter}]`, 1]
    };

    Blockly.PythonDebug.operator_length = function (a) {
        let string = Blockly.PythonDebug.valueToCode(a, "STRING", 2)
        return [`len(${string})`, 1]
    };

    Blockly.PythonDebug.operator_contains = function (a) {
        let string1 = Blockly.PythonDebug.valueToCode(a, "STRING1", 2)
        let string2 = Blockly.PythonDebug.valueToCode(a, "STRING2", 2)
        return [`${string1} in ${string2}`, 1]
    };



    //部分模块转换

    Blockly.PythonDebug.text = function (a) {
        let textValue = a.getFieldValue("TEXT") || ''
        if (isNaN(textValue * 1)) {
            textValue = '"' + textValue + '"'
            return [textValue, 3]
        } else {
            return [textValue, 3]
        }

    }

    Blockly.PythonDebug.math_integer = function (a) {
        let value = a.getFieldValue('NUM') || 'null'
        return [value, 1]
    };

    Blockly.PythonDebug.math_number = function (a) {
        let value = a.getFieldValue('NUM') || 'null'
        return [value, 1]
    };
    Blockly.PythonDebug.math_whole_number = function (a) {
        let value = a.getFieldValue('NUM') || 'null'
        return [value, 1]
    };

    Blockly.PythonDebug.jmd_time_menu = function (a) {
        let time = a.getFieldValue('TIME') || 'null'
        return [time, 1]
    };

    Blockly.PythonDebug.motor_speed_menu = function (a) {
        let value = a.getFieldValue('VALUE') || 'null'
        return [value, 1]
    };

    Blockly.PythonDebug.motor_angle_menu = function (a) {
        let angle = a.getFieldValue('ANGLE') || 'null'
        return [angle, 1]
    };

    Blockly.PythonDebug.motor_angle_menu_two = function (a) {
        let angle = a.getFieldValue('ANGLE') || 'null'
        return [angle, 1]
    };

    Blockly.PythonDebug.motor_angle_menu_three = function (a) {
        let angle = a.getFieldValue('ANGLE') || 'null'
        return [angle, 1]
    };

    Blockly.PythonDebug.show_lines_menu = function (a) {
        let lines = a.getFieldValue('LINES') || 'null'
        return [lines, 1]
    };
    Blockly.PythonDebug.play_folder_menu = function (a) {
        let foldername = a.getFieldValue('FOLDERNAME') || 'null'
        return [foldername, 1]
    };

    Blockly.PythonDebug.play_music_menu = function (a) {
        let musicname = a.getFieldValue('MUSICNAME') || 'null'
        return [musicname, 1]
    };

    Blockly.PythonDebug.colour_picker = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };

    Blockly.PythonDebug.colour_picker_Red = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };

    Blockly.PythonDebug.colour_picker_Orange = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };
    Blockly.PythonDebug.colour_picker_Yellow = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };
    Blockly.PythonDebug.colour_picker_Green = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };
    Blockly.PythonDebug.colour_picker_Blue = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };
    Blockly.PythonDebug.colour_picker_Indigo = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };
    Blockly.PythonDebug.colour_picker_Purple = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };
    Blockly.PythonDebug.colour_picker_White = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };

    Blockly.PythonDebug.matrix = function (a) {
        let matrix = a.getFieldValue('MATRIX') || 'null'
        return [matrix, 1]
    };









    // 变量
    Blockly.PythonDebug.variables = {};
    Blockly.PythonDebug.variablesHead = "VAR_";
    Blockly.PythonDebug.data_variable = function (a) {
        let varible = a.workspace.getVariableById(a.getFieldValue("VARIABLE")) ? a.workspace.getVariableById(a.getFieldValue("VARIABLE")).name : ""

        varible = Blockly.PythonDebug.variablesHead + varible

        return [varible, Blockly.PythonDebug.ORDER_ATOMIC]
    };
    Blockly.PythonDebug.data_setvariableto = function (a) {
        let varible = a.workspace.getVariableById(a.getFieldValue("VARIABLE")) ? a.workspace.getVariableById(a.getFieldValue("VARIABLE")).name : ""
        let num = Blockly.PythonDebug.valueToCode(a, "VALUE", 2)
        varible = Blockly.PythonDebug.variablesHead + varible
        return `${varible} = ${num}\r\n`
    };
    Blockly.PythonDebug.data_changevariableby = function (a) {
        let varible = a.workspace.getVariableById(a.getFieldValue("VARIABLE")) ? a.workspace.getVariableById(a.getFieldValue("VARIABLE")).name : ""
        let num = Blockly.PythonDebug.valueToCode(a, "VALUE", 2)
        varible = Blockly.PythonDebug.variablesHead + varible
        return `${varible} += ${num}\r\n`
    };




    // 自制积木

    // %s 数字类型控件 argument_reporter_string_number
    // %d 布尔类型控件 argument_reporter_boolean


    Blockly.PythonDebug.procedures_definition = function (a) {
        let b = Blockly.PythonDebug.blockToCode(a.workspace.getBlockById(a.getChildren(a)[0].id))
        return "def " + b + ":[GLOBAL]\r\n";
    };
    Blockly.PythonDebug.procedures_prototype = function (a) {
        // console.log('procedures_prototype', a)
        let fnName = a.getProcCode().replace(/%[sbn\s]|\s/ig, '').trim()
        let children = a.getChildren(a)
        let array = []
        for (let i = 0; i < children.length; i++) {
            if (a.workspace.getBlockById(children[i].id)) {
                let value = Blockly.PythonDebug.blockToCode(a.workspace.getBlockById(children[i].id))
                array.push(value[0])
            }
        }
        fnName += `(${array.join(',')})`

        return fnName;
    };
    Blockly.PythonDebug.argument_reporter_boolean = function (a) {
        // console.log('argument_reporter_boolean', a)
        let text = a.inputList[0].fieldRow[0].getText()
        // console.log(a.inputList[0].fieldRow[0].getText())
        return [text, 1];
    };
    Blockly.PythonDebug.argument_reporter_string_number = function (a) {
        // console.log('argument_reporter_string_number', a)
        let text = a.inputList[0].fieldRow[0].getText()
        // console.log(a.inputList[0].fieldRow[0].getText())

        return [text, 5];
    };

    Blockly.PythonDebug.procedures_call = function (a) {
        // console.log('procedures_call', a)

        let array = []
        let fnName = a.getProcCode().replace(/(%s|%b|%n)|\s/ig, '')

        for (let i = 0; i < a.inputList.length; i++) {
            if (a.inputList[i].name !== '') {
                let blocks = a.inputList[i].connection.targetBlock()
                if (blocks) {
                    let child = Blockly.PythonDebug.blockToCode(a.workspace.getBlockById(blocks.id))
                    if (Array.isArray(child)) {
                        if (!(/[^\s]/ig.test(child[0]))) {
                            array.push('"' + child[0] + '"')
                        } else {
                            array.push(child[0])
                        }
                    } else {
                        array.push(child)
                    }
                } else {
                    array.push('False')
                }
            }
        }

        fnName += `(${array.join(',')})`

        return `${fnName};\r\n`;
    };


}

export {
    toPythonDebug
}
